import { EQUIPMENT_TYPE } from '@store/Equipments/actionTypes';
import { NodeType } from '@store/connections/actionTypes';

import cellSVG from "@assets/icons/cell.svg";
import consumerSVG from "@assets/icons/consumer.svg";
import counterSVG from "@assets/icons/counter.svg";
import networkSVG from "@assets/icons/network.svg";
import shieldSVG from "@assets/icons/shield.svg";
import transformerSVG from "@assets/icons/transformer.svg";


export interface NodeTypeDescription {
  type: NodeType;
  icon: string;
  color: string;
  input: boolean;
  output: boolean;
  kind?: EQUIPMENT_TYPE;
}

export const nodesDescriptions: NodeTypeDescription[] = [
  { type: "cell", color: "#DFF9E8", icon: cellSVG, input: false, output: true, kind: EQUIPMENT_TYPE.ELECTRICAL },
  { type: "transformer", color: "#FBEDFF", icon: transformerSVG, input: true, output: true, kind: EQUIPMENT_TYPE.ELECTRICAL },
  { type: "counter", color: "#DCEAFF", icon: counterSVG, input: true, output: true, kind: EQUIPMENT_TYPE.ELECTRICAL },
  { type: "shield", color: "#F3E8E2", icon: shieldSVG, input: true, output: true, kind: EQUIPMENT_TYPE.ELECTRICAL },
  //{ type: "building",    color: "#E8F3E2", icon: buildingSVG,    input: true,  output: true, kind: EQUIPMENT_TYPE.ELECTRICAL },

  { type: "consumer", color: "#FFFEE2", icon: consumerSVG, input: true, output: false },

  { type: "square", color: "#DFF9E8", icon: networkSVG, input: true, output: true, kind: EQUIPMENT_TYPE.NETWORK },
  { type: "triangle", color: "#FBEDFF", icon: networkSVG, input: true, output: true, kind: EQUIPMENT_TYPE.NETWORK },
  { type: "circle", color: "#DCEAFF", icon: networkSVG, input: true, output: true, kind: EQUIPMENT_TYPE.NETWORK },
  { type: "diamond", color: "#F3E8E2", icon: networkSVG, input: true, output: true, kind: EQUIPMENT_TYPE.NETWORK },
];

type NodesMap = {
  [k in NodeType]: NodeTypeDescription
}

export const nodesDescriptionMap: NodesMap = Object.fromEntries(nodesDescriptions.map(node => [node.type, node])) as NodesMap;

